<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d)">
<rect x="10" y="6" width="40" height="40" rx="20" fill="white"/>
</g>
<path d="M34.1113 31.3H23.5171C22.6686 31.3 22 30.6217 22 29.8178V22.4822C22 21.6532 22.6943 21 23.5171 21H34.0856C34.9341 21 35.6027 21.6783 35.6027 22.4822V29.7927C35.6284 30.6217 34.9341 31.3 34.1113 31.3Z" fill="#9B9BCE"/>
<path d="M35.3713 23.9143V28.3861L39.6141 30.7224C39.7941 30.8229 39.9999 30.6973 39.9999 30.4963V21.8041C39.9999 21.6031 39.7941 21.5026 39.6141 21.578L35.3713 23.9143Z" fill="#9B9BCE"/>
<defs>
<filter id="filter0_d" x="0" y="0" width="60" height="60" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="5"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
</filter>
</defs>
</svg>
